import { SourceItem, SourceResult } from './types';

// Normalize source result to SourceItem array
export const normalizeSourceResult = (result: SourceResult): SourceItem[] => {
  return result.map(item => {
    if (typeof item === 'string') {
      return { url: item };
    }
    return item;
  });
};

// Evaluate JavaScript code
export const evaluateSource = async (code: string): Promise<SourceItem[]> => {
  try {
    // Wrap in async function to handle both sync and async returns
    const AsyncFunction = Object.getPrototypeOf(async function() {
    }).constructor;
    const fn = new AsyncFunction(`return (${code})`);
    const result = await fn();
    return normalizeSourceResult(result);
  } catch (error) {
    console.error('Error evaluating slideshow source:', error);
    return [];
  }
};

// Parse newline-separated URLs
export const parseUrls = (text: string): SourceItem[] => {
  return text
    .split('\n')
    .map(url => url.trim())
    .filter(url => url.length > 0)
    .map(url => ({ url }));
};
